<template>
  <div :id="`knockout-${carCountFail}`" class="row mt-2 py-2 knockout-wrap smaller-font-content bg-white shadow-sm">
    <div class="col-3 text-center">
    <div class="carrierLogo" :id="carrier.carrier_name"><img :src="carrier.logoPathSvg" :alt="carrier.carrier_name" width="100%" height="auto"/></div>
    </div>
    <div class="col-9 my-auto" v-html="carrier.status_message">
    </div>
  </div>
</template>

<script>
/**
 * CarrierDetailsFailure.vue component represents a single carrier's failed attempt at receiving an insurance rate.
 * This failed carrier is called a 'Knockout' and will have its own distinct section with a header element called 'Knockouts'
 *
 * CarrierDetailsFailure.vue is a child component of CarrierMatches. In CarrierMatches, we v-for through our carrierErrorArray[]
 * to display all UNsuccessful carriers on the page. Each CarrierDetailsFailure.vue is passed a Vue JS 'prop' for communication between
 * the Parent (CarrierMatches) component and the child (CarrierDetailsFailure) component.
 *
 * We can see we name this Vue JS prop 'carrier' below:
 * Search for: props: ['carrier'],
 * So this 'carrier' property will hold All the necessary information to display this Carrier Failure widget.
 *
 * A single Carrier Failure widget will be represented by a logo and descriptive message on why the carrier failed.
 */
export default {
  props: ['carrier', 'carCountFail'],
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="scss">
  /***Insurance Carrier Column***/
  #results-table .carrierLogo img, #knockout-wrap .carrierLogo img{
    width: 100% !important;
    max-width: 150px;
    height: inherit !important;
    max-height: 60px;
  }

  /**KNOCKOUT LISTING CSS**/
  .knockout-wrap{
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
    display: flex;
    align-items: center;
    color: $var-color-faint-gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/interview/Auto/RC1/CarrierDetailsFailure.vue?551d1848